module.exports = require("core-js-pure/stable/instance/trim-left");